const CubesIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_51)">
        <g clipPath="url(#clip1_14_51)">
          <path
            d="M12.0984 4.70898L14.8547 5.75313L12 6.85L9.14531 5.75313L11.9016 4.70898C11.9648 4.68438 12.0352 4.68438 12.102 4.70898H12.0984ZM6.65625 6.25234V10.1969C6.61055 10.2109 6.56484 10.225 6.51914 10.2426L3.14414 11.5223C2.38125 11.8105 1.875 12.5453 1.875 13.3609V17.5516C1.875 18.332 2.33555 19.0387 3.05273 19.3551L6.42773 20.8387C6.93398 21.0602 7.50703 21.0602 8.01328 20.8387L12 19.0844L15.9902 20.8387C16.4965 21.0602 17.0695 21.0602 17.5758 20.8387L20.9508 19.3551C21.6645 19.0422 22.1285 18.332 22.1285 17.5516V13.3609C22.1285 12.5418 21.6223 11.8105 20.8594 11.5188L17.4844 10.2391C17.4387 10.2215 17.393 10.2074 17.3473 10.1934V6.25234C17.3473 5.4332 16.841 4.70195 16.0781 4.41016L12.7031 3.13047C12.2531 2.96172 11.7574 2.96172 11.3074 3.13047L7.93242 4.41016C7.1625 4.70195 6.65625 5.43672 6.65625 6.25234ZM15.6562 10.4043L12.7594 11.5012V8.36523L15.6562 7.2543V10.4043ZM7.31719 11.8211L10.0734 12.8652L7.21875 13.9586L4.36406 12.8652L7.12031 11.8211C7.18359 11.7965 7.25391 11.7965 7.3207 11.8211H7.31719ZM7.97813 19.007V15.4738L10.875 14.3629V17.7344L7.97813 19.007ZM16.6828 11.8211C16.7461 11.7965 16.8164 11.7965 16.8832 11.8211L19.6395 12.8652L16.7812 13.9586L13.9266 12.8652L16.6828 11.8211ZM20.2688 17.8082L17.5406 19.007V15.4738L20.4375 14.3629V17.5516C20.4375 17.6641 20.3707 17.7625 20.2688 17.8082Z"
            fill="#0051FF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_14_51">
          <rect width="20.25" height="18" fill="white" transform="translate(1.875 3)" />
        </clipPath>
        <clipPath id="clip1_14_51">
          <path d="M1.875 3H22.125V21H1.875V3Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CubesIcon;
